
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_12693_217054)"}},[_c('path',{attrs:{"d":"M0 0h20v20H0V0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.25 14.2s-.75 0-.75-.75.75-3 3.75-3 3.75 2.25 3.75 3-.75.75-.75.75h-6zM12.25 9.7a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM7.912 14.2a1.678 1.678 0 01-.162-.75c0-1.017.51-2.062 1.452-2.79a4.744 4.744 0 00-1.452-.21c-3 0-3.75 2.25-3.75 3s.75.75.75.75h3.162zM7.375 9.7a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_12693_217054"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    